import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['detail'];

  toggleDetail(e) {
    if (e.target.checked) {
      $(this.detailTarget).show('fast');
    } else {
      $(this.detailTarget).hide('fast');
    }
  }
}
